export default __webpack_public_path__ + "ed1de4e9e411ebb761e0f550489057df.svg";